import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierAddressesController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAddressesController.php
* @route '/api/dossier/addresses/{dossier}'
*/
const GetDossierAddressesController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierAddressesController.url(args, options),
    method: 'get',
})

GetDossierAddressesController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/addresses/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierAddressesController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAddressesController.php
* @route '/api/dossier/addresses/{dossier}'
*/
GetDossierAddressesController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierAddressesController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierAddressesController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAddressesController.php
* @route '/api/dossier/addresses/{dossier}'
*/
GetDossierAddressesController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierAddressesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierAddressesController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierAddressesController.php
* @route '/api/dossier/addresses/{dossier}'
*/
GetDossierAddressesController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierAddressesController.url(args, options),
    method: 'head',
})

export default GetDossierAddressesController